import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import { MessageText } from "../../MessageText";
import { getInputInstanceByProps } from "./utils/getInputInstanceByProps";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Input = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var autoComplete = _ref.autoComplete,
    disabled = _ref.disabled,
    inputRef = _ref.inputRef,
    id = _ref.id,
    name = _ref.name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return false;
    } : _ref$onChange,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return false;
    } : _ref$onClick,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {
      return false;
    } : _ref$onBlur,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {
      return false;
    } : _ref$onFocus,
    _ref$onKeyPress = _ref.onKeyPress,
    onKeyPress = _ref$onKeyPress === void 0 ? function () {
      return false;
    } : _ref$onKeyPress,
    onClear = _ref.onClear,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    type = _ref.type,
    value = _ref.value,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Input' : _ref$testName,
    errorMessage = _ref.errorMessage,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    helpMessage = _ref.helpMessage,
    label = _ref.label,
    extraAttributes = _ref.extraAttributes,
    leftAside = _ref.leftAside,
    rightAside = _ref.rightAside,
    bottomLayoutNode = _ref.bottomLayoutNode,
    maskSettings = _ref.maskSettings,
    onValueChange = _ref.onValueChange,
    isTextArea = _ref.isTextArea,
    isTextAreaResizable = _ref.isTextAreaResizable,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size;
  var InputInstance = useMemo(function () {
    return getInputInstanceByProps({
      type: type,
      maskSettings: maskSettings,
      isTextArea: isTextArea
    });
  }, [type, maskSettings, isTextArea]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('input', className),
    "data-component": testName,
    "data-t-id": "inputs-Input"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('input__container')
  }, /*#__PURE__*/React.createElement(InputInstance, {
    className: cn('input__field', (_cn = {
      'input__field--indent-right': type === 'password' || rightAside || onClear
    }, _defineProperty(_cn, "input-size-".concat(size), Boolean(size)), _defineProperty(_cn, 'input__field--indent-left', leftAside), _defineProperty(_cn, 'input__field--read-only', readOnly), _defineProperty(_cn, "textarea", isTextArea), _defineProperty(_cn, 'textarea--resizable', isTextAreaResizable), _defineProperty(_cn, 'input__field--error', error || !!errorMessage), _cn)),
    disabled: disabled,
    inputProps: _objectSpread(_objectSpread({}, extraAttributes), {}, {
      autoComplete: autoComplete,
      id: id,
      name: name,
      placeholder: placeholder,
      readOnly: readOnly,
      value: value,
      onBlur: onBlur,
      onChange: onChange,
      onClick: onClick,
      onFocus: onFocus,
      onKeyPress: onKeyPress
    }),
    inputRef: inputRef,
    isTextArea: isTextArea,
    label: label,
    leftAside: leftAside,
    maskSettings: maskSettings,
    onClear: onClear,
    onValueChange: onValueChange,
    rightAside: rightAside,
    type: type
  }), bottomLayoutNode), (errorMessage || helpMessage) && /*#__PURE__*/React.createElement(MessageText, {
    errorMessage: errorMessage,
    helpMessage: helpMessage
  }));
});